module.exports = __webpack_public_path__ + "img/check.91e6ec70.png";